import { useTheme } from "@mui/material";
import { StyledTopSectionWrapperSkeleton, StyledSkeleton, StyledContentListSkeleton } from "./styledComponents";

/**
 * content list skeleton
 */
export function ContentListSkeleton() {
    const theme = useTheme();

    return (
        <StyledContentListSkeleton className={"kms-ds-edit-playlist-content-list-skeleton"}>
            <StyledTopSectionWrapperSkeleton>
                <StyledSkeleton variant="rectangular" width={theme.spacing(6)} height={theme.spacing(2)} />
                <StyledSkeleton variant="rectangular" width={theme.spacing(18)} height={theme.spacing(4)} />
            </StyledTopSectionWrapperSkeleton>
            <StyledSkeleton variant="rectangular" width={"100%"} height={theme.spacing(30)} />
        </StyledContentListSkeleton>
    );
}
